var layout_default = {
  "layout": "mO9dL",
  "cell": "_8R1l-"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
